export const FETCH_LOGIN_DATA = "FETCH_LOGIN_DATA";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const REGISTER_BRAND_OWNER = "REGISTER_BRAND_OWNER";
export const REGISTER_BRAND_USER = "REGISTER_BRAND_USER";
export const REGISTER_CATEGORY_STORE = "REGISTER_CATEGORY_STORE";
export const CREATE_ROLE = "CREATE_ROLE";
export const UPDATE_STATUS_CODE = "UPDATE_STATUS_CODE";
export const UPDATE_STATUS_USERS = "UPDATE_STATUS_USERS";
export const UPDATE_STATUS_BRAND = "UPDATE_STATUS_BRAND";
export const VIEW_USERS = "VIEW_USERS";
export const VIEW_PRODUCTS = "VIEW_PRODUCTS";
export const VIEW_REPORT_PROBLEM = "VIEW_REPORT_PROBLEM";
export const GET_SERIAL_FOR_BATCH = "GET_SERIAL_FOR_BATCH";
export const VIEW_ACTIVE_PRODUCTS = "VIEW_ACTIVE_PRODUCTS";
export const VIEW_ROLES = "VIEW_ROLES";
export const ASSIGN_PERMISSIONS = "ASSIGN_PERMISSIONS";
export const UPDATE_RATE_LIMIT = "UPDATE_RATE_LIMIT";
export const GET_BATCH_PRODUCT = "GET_BATCH_PRODUCT";
export const GETALL_PERMISSION = "GETALL_PERMISSION";
export const ROLE_PERMISSIONS = "ROLE_PERMISSIONS";
export const EDIT_USER = "EDIT_USER";
export const ALL_BRAND = "ALL_BRAND";
export const MAP_DATA = "MAP_DATA";

export const ALL_FAQS = "ALL_FAQS";
export const ALL_TERMS = "ALL_TERMS";
export const EDIT_COLOR_SHIFT = "EDIT_COLOR_SHIFT";
export const EDIT_SMSREPLY = "EDIT_SMSREPLY";
export const GETALL_CATEGEORY = "GETALL_CATEGEORY";
export const GET_ALL_COLOR_SHIFT = "GET_ALL_COLOR_SHIFT";
export const ALL_SMS_REPLY = "ALL_SMS_REPLY";
export const STATUS_UPDATE_SMSREPLY = "STATUS_UPDATE_SMSREPLY";
export const BRAND_ONE_DETAIL = "BRAND_ONE_DETAIL";
export const BRAND_EDIT = "BRAND_EDIT";
export const EDIT_CATEGORY = "EDIT_CATEGORY";
export const GET_ALL_ACTIVE_COMPANIES = "GET_ALL_ACTIVE_COMPANIES";
export const GET_ALL_ACTIVE_BRANDS = "GET_ALL_ACTIVE_BRANDS";
export const ALL_SUB_CATEGORIES = "ALL_SUB_CATEGORIES";
export const SUB_CATEGORY_SATUS_UPDATE = "SUB_CATEGORY_SATUS_UPDATE";
export const STATUS_UPDATE_CATEGORY = "STATUS_UPDATE_CATEGORY";
export const CREATE_SUB_CATEGORY = "CREATE_SUB_CATEGORY";
export const EDIT_SUB_CATEGORY = "EDIT_SUB_CATEGORY";
export const ALL_COMPANY = "ALL_COMPANY";
export const POST_SMS_REPLY = "POST_SMS_REPLY";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const POST_UPDATE_FAQS = "POST_UPDATE_FAQS";
export const POST_UPDATE_TERMS = "POST_UPDATE_TERMS";
export const ALL_BATCHES = "ALL_BATCHES";
export const ALL_BATCHES_BOTH_GET = "ALL_BATCHES_BOTH_GET";
export const ALL_CUSTOM_BATCHES = "ALL_CUSTOM_BATCHES";
export const ALL_GET_CUSTOMER = "ALL_GET_CUSTOMER";
export const ACTIVE_GET_CUSTOMER = "ACTIVE_GET_CUSTOMER";
export const ALL_POST_CUSTOMER = "ALL_POST_CUSTOMER";
export const UPDATE_POST_CUSTOMER = "UPDATE_POST_CUSTOMER";
export const UPDATE_STATUS_CUSTOMER = "UPDATE_STATUS_CUSTOMER";
export const ALL_BATCHES_COMPANY = "ALL_BATCHES_COMPANY";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const STATUS_UPDATE_COMPANY = "STATUS_UPDATE_COMPANY";
export const COMPANY_DETAIL_ONE_USER = "COMPANY_DETAIL_ONE_USER";
export const All_COUNTS = "All_COUNTS";
// export const All_COUNTS = 'GET_ALL_COUNTS';
export const All_RANDOM_CODE = "GET_ALL_RANDOM_CODE";
export const REQUEST_RANDOM_CODE = "REQUEST_RANDOM_CODE";
export const POST_CUSTOM_BATCH = "POST_CUSTOM_BATCH";
export const VIEW_CUSTOM_BATCH = "VIEW_CUSTOM_BATCH";
export const POST_UPDATE_CUSTOM_BATCH = "POST_UPDATE_CUSTOM_BATCH";
export const ALL_SMS_LOGS = "GET_ALL_SMS_LOGS";
export const GET_CSV = "GET_CSV";

export const ALL_SMS_REPORT = "GET_ALL_SMS_REPORT";
export const ALL_QRCODE_REPORT = "GET_ALL_QRCODE_REPORT";
export const EXPORT_CSV = "EXPORT_CSV";
export const EXPORT_QR_CSV = "EXPORT_QR_CSV";
export const EXPORT_CSV_COMPANY = "EXPORT_CSV_COMPANY";
export const EXPORT_CSV_REPORT_PROBLEM = "EXPORT_CSV_REPORT_PROBLEM";
export const EXPORT_CSV_CATEGORYIES = "EXPORT_CSV_CATEGORYIES";
export const EXPORT_CSV_RANDOM_CODE = "EXPORT_CSV_RANDOM_CODE";
export const PROGRESSIVE_CODES = "PROGRESSIVE_CODES";
export const VERIFICATION_LOGINN = "VERIFICATION_LOGINN";
export const PER_POST_ID = "PER_POST_ID";
export const ALL_CUSTOMBATCH_EXPORT = "ALL_CUSTOMBATCH_EXPORT";
export const FETCHCODERANGE = "FETCH_CODE_RANGE";
export const RESET_FETCHED_CODE = "RESET_FETCHED_CODE";
export const BY_BATCH_CSV_DATA = "BY_BATCH_CSV_DATA";


export const BRAND_OWNER_CLIENTS = "BRAND_OWNER_CLIENTS";
export const BRAND_OWNER_CLIENTS_CREATE = "BRAND_OWNER_CLIENTS_CREATE";
export const BRAND_OWNER_CLIENTS_CREATE_RESET = "BRAND_OWNER_CLIENTS_CREATE_RESET";
export const BRAND_OWNER_CHANGE_PASSWORD = "BRAND_OWNER_CHANGE_PASSWORD";
export const CREATE_TOKEN_BRAND = "CREATE_TOKEN_BRAND";
export const CREATE_TOKEN_BRAND_RESET = "CREATE_TOKEN_BRAND_RESET";
export const BRAND_CLIENT_TOKEN_DATA = "BRAND_CLIENT_TOKEN_DATA";
export const BRAND_CLIENTS_REVOKE = "BRAND_CLIENTS_REVOKE";
export const BRAND_CLIENT_TOKEN_REVOKE = "BRAND_CLIENT_TOKEN_REVOKE";
export const ALL_OAUTH_COMPANIES = "ALL_OAUTH_COMPANIES";


// ====================================== NEW PROJECT ===================================================


export const VIEW_PROJECTS = "VIEW_PROJECTS";
export const CREATE_PROJECTS = "CREATE_PROJECTS";

// Master Data Actions
export const VIEW_BUILDINGS = "VIEW_BUILDINGS";
export const VIEW_MANUFACTURERS = "VIEW_MANUFACTURERS";
export const VIEW_CAPACITY_UOMS = "VIEW_CAPACITY_UOMS";
export const VIEW_TAG_CONDITIONS = "VIEW_TAG_CONDITIONS";
export const VIEW_DEPARTMENTS = "VIEW_DEPARTMENTS";

export const VIEW_FLOORS = "VIEW_FLOORS";
export const VIEW_ROOMS = "VIEW_ROOMS";
export const VIEW_PHOTO_TYPES = "VIEW_PHOTO_TYPES";
export const VIEW_CONDITIONS = "VIEW_CONDITIONS";
export const VIEW_ASSET_DESCRIPTIONS = "VIEW_ASSET_DESCRIPTIONS";

export const VIEW_EXISTING_ASSETS = "VIEW_EXISTING_ASSETS";
export const VIEW_CUSTOM_ATTRIBUTES = "VIEW_CUSTOM_ATTRIBUTES";

// Dashboard Actions (Sheet 8)
export const VIEW_DASHBOARD_PROGRESS = "VIEW_DASHBOARD_PROGRESS";
export const VIEW_DASHBOARD_COLLECTOR_PROGRESS = "VIEW_DASHBOARD_COLLECTOR_PROGRESS";
export const VIEW_DASHBOARD_LOCATION_PROGRESS = "VIEW_DASHBOARD_LOCATION_PROGRESS";
export const VIEW_DASHBOARD_QUALITY = "VIEW_DASHBOARD_QUALITY";
export const VIEW_DASHBOARD_STATUS_FUNNEL = "VIEW_DASHBOARD_STATUS_FUNNEL";
export const VIEW_DASHBOARD_MAP = "VIEW_DASHBOARD_MAP";

// Project Asset Hierarchy Download
export const VIEW_PROJECT_ASSETS_DOWNLOAD = "VIEW_PROJECT_ASSETS_DOWNLOAD";
export const REQUEST_PROJECT_ASSETS_DOWNLOAD = "REQUEST_PROJECT_ASSETS_DOWNLOAD";
export const FAIL_PROJECT_ASSETS_DOWNLOAD = "FAIL_PROJECT_ASSETS_DOWNLOAD";
export const CANCEL_PROJECT_ASSETS_DOWNLOAD = "CANCEL_PROJECT_ASSETS_DOWNLOAD";

// ====================================== NEW PROJECT ===================================================
